
import { AmmunitionStock } from './ammunition-stock.model';
import { AmmunitionStockTypeInfoBase } from './ammunition-stock.typeinfo.base';


export class AmmunitionStockTypeInfo extends AmmunitionStockTypeInfoBase {
  stocktakeRouteBase = ['/ammunitionstock/stocktake'];
  additionsRouteBase = ['/ammunitionstock/additions'];
  issueRouteBase = ['/ammunitionstock/issue'];
  returnRouteBase = ['/ammunitionstock/return']

  description(item: AmmunitionStock): string {
    return '' + item.businessUnit?.buId + "/" + item.costCentre?.ccId + " - " + this.descriptionSmall(item);
  }

  descriptionSmall(item: AmmunitionStock): string {
    return '' + item.calibre + " " + item.make + " (" + item.weight + ")";
  }
}

export const AMMUNITION_STOCK_TYPE: AmmunitionStockTypeInfo = new AmmunitionStockTypeInfo();



